/** @jsx jsx */
import React from 'react';
import { styled, css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import DeploymentIcons, {
	type DeploymentState,
} from '@atlassian/jira-software-deployments-icons-common';

type Props = {
	children: string;
	color: string;
	state: DeploymentState;
};

const Key = ({ children, color, state }: Props) => (
	<KeyWrapper color={color} data-testid="software-deployments.ui.timeline.legend.key.legend-key">
		<span css={keyIconWrapperStyles}>
			<DeploymentIcons deploymentState={state} size="small" />
		</span>
		{children}
	</KeyWrapper>
);

interface KeyWrapperProps {
	color: string;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const KeyWrapper = styled.li<KeyWrapperProps>({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props: KeyWrapperProps) => props.color,
	alignItems: 'center',
	paddingTop: token('space.100', '8px'),
	paddingBottom: token('space.100', '8px'),
	margin: 0,
});

const keyIconWrapperStyles = css({
	display: 'flex',
	marginRight: token('space.075', '6px'),
});

export default Key;
